import React from 'react'
import { Link } from 'react-router-dom'

const BottomMenu = ({gameId, teamId}) => {
  return (
    <div className='md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-purple-800/20 p-2 text-purple-700 flex items-center'>
        <Link to="/game" state={{gameId: gameId, teamId: teamId}} className='flex-1 text-center'>
            <i className='bi bi-house-door text-2xl'></i>
            <div className='text-sm text-gray-700'>ホーム</div>
        </Link>
        <Link to="/game/missions" state={{gameId: gameId, teamId: teamId}} className='flex-1 text-center'>
            <i className='bi bi-clipboard-check text-2xl'></i>
            <div className='text-sm text-gray-700'>ミッション</div>
        </Link>
        <Link to="/game/map" state={{gameId: gameId, teamId: teamId}} className='flex-1 text-center'>
            <i className='bi bi-map text-2xl'></i>
            <div className='text-sm text-gray-700'>マップ</div>
        </Link>
        <Link to="/game/specialItems" state={{gameId: gameId, teamId: teamId}} className='flex-1 text-center'>
            <i className='bi bi-collection text-2xl'></i>
            <div className='text-sm text-gray-700'>アイテム</div>
        </Link>
        <Link to="/game/history" state={{gameId: gameId, teamId: teamId}} className='flex-1 text-center'>
            <i className='bi bi-clock-history text-2xl'></i>
            <div className='text-sm text-gray-700'>履歴</div>
        </Link>
    </div>
  )
}

export default BottomMenu